import { render, staticRenderFns } from "./NotificationConfiguration.vue?vue&type=template&id=33cc5b99"
import script from "./NotificationConfiguration.vue?vue&type=script&lang=js"
export * from "./NotificationConfiguration.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfiguration.vue?vue&type=style&index=0&id=33cc5b99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports